module.exports = __webpack_public_path__ + "media/Landing-Page-BG_Animation.5383f9be.mp4";